import React from "react";

export const MixedSelectAndInputField = ({
  label,
  tooltip,
  value1,
  onChange1,
  options1,
  name1,
  defaultDisabledValue1,
  value2,
  onChange2,
  placeholder2,
  id2,
  name2,
  type2,
  isRequired,
}) => {
  return (
    <div className="flex flex-col space-y-1 mb-4">
      <label className="text-gray-700 font-medium text-sm">
        {label}
        {isRequired && (
          <span className="text-xs text-gray-500">(required)</span>
        )}
      </label>
      <div className="flex gap-1 items-center">
        <select
          name={name1}
          className={
            "w-4/12 text-sm bg-white border border-gray-300 rounded-l-lg p-2 my-auto h-[38px] text-gray-900 focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent"
          }
          value={value1}
          onChange={onChange1}
        >
          <option defaultValue={""} className="text-gray-200">
            {defaultDisabledValue1 ? defaultDisabledValue1 : "Select"}
          </option>

          {options1?.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <input
          type={type2 || "text"}
          id={id2}
          name={name2}
          placeholder={placeholder2 || ""}
          onChange={onChange2}
          value={value2}
          className="w-8/12 text-sm border border-gray-300 rounded-r-lg p-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent"
          aria-describedby="tooltip"
        />
      </div>

      {tooltip && (
        <p id="tooltip" className="text-xs text-gray-500">
          {tooltip}
        </p>
      )}
    </div>
  );
};

export const MixedSelectAndInputFieldRight = ({
  label,
  tooltip,
  value1,
  onChange1,
  options1,
  name1,
  defaultDisabledValue1,
  value2,
  onChange2,
  placeholder2,
  id2,
  name2,
  type2,
  isRequired,
}) => {
  return (
    <div className="flex flex-col space-y-1 mb-4">
      <label className="text-gray-700 font-medium text-sm">
        {label}
        {isRequired && (
          <span className="text-xs text-gray-500">(required)</span>
        )}
      </label>
      <div className="flex gap-0.5 items-center">
        <input
          type={type2 || "text"}
          id={id2}
          name={name2}
          placeholder={placeholder2 || ""}
          onChange={onChange2}
          value={value2}
          className="w-9/12 text-sm border border-gray-300 rounded-l-lg p-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent"
          aria-describedby="tooltip"
        />
        <select
          name={name1}
          className={
            "w-3/12 text-sm bg-white border border-gray-300 rounded-r-lg p-2 my-auto h-[38px] text-gray-900 focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent"
          }
          value={value1}
          onChange={onChange1}
        >
          <option defaultValue={""} className="text-gray-200">
            {defaultDisabledValue1 ? defaultDisabledValue1 : "Select"}
          </option>

          {options1?.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      {tooltip && (
        <p id="tooltip" className="text-xs text-gray-500">
          {tooltip}
        </p>
      )}
    </div>
  );
};
